import React from 'react';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import isBetween from 'dayjs/plugin/isBetween';
import BaseInput from './base';

dayjs.extend(customParseFormat);
dayjs.extend(isBetween);

const Input = inputProps => (
  <BaseInput
    label=""
    type="number"
    name="income"
    maxLength={8}
    autoComplete="off"
    transparent
    useLocalState={false}
    {...inputProps}
  />
);

const DownPayment = ({ onTouched, onChange, ...rest }) => (
  <NumberFormat
    thousandSeparator
    prefix="$"
    onValueChange={values =>
      onChange({ ...values, name: 'downPayment', type: 'number' })
    }
    {...rest}
    onTouched={onTouched}
    customInput={Input}
    style={{ fontSize: '1.5rem', paddingBottom: '2px' }}
  />
);

DownPayment.propTypes = {
  onChange: PropTypes.func.isRequired,
  onTouched: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  error: PropTypes.string
};

DownPayment.defaultProps = {
  onTouched: null,
  value: '',
  error: ''
};

export default DownPayment;
